window.__scrollRevealObserver =
  window.__scrollRevealObserver ||
  new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );

window.initScrollReveal = function initScrollReveal(root) {
  const scope = root || document;
  const targets = scope.querySelectorAll('[data-animate]:not(.is-visible)');

  targets.forEach((el) => {
    window.__scrollRevealObserver.observe(el);
  });
};

document.addEventListener('DOMContentLoaded', () => window.initScrollReveal());

// The theme editor re-renders a section in place after every setting change;
// without re-observing, its fresh [data-animate] nodes would stay hidden.
document.addEventListener('shopify:section:load', (event) => {
  window.initScrollReveal(event.target);
});

/** Dialogs with a sliding `[data-slide-panel]` child (nav-drawer,
    cart-drawer) can't rely on `@starting-style` for the panel's own
    transform: that only reliably fires for a property changing on the
    dialog itself, not on a descendant that merely becomes visible when
    the dialog does. Driving the open/closed position with a JS-toggled
    class sidesteps that and works everywhere. */
const pendingDialogCloses = new WeakMap();

function cancelPendingDialogClose(dialog) {
  const pending = pendingDialogCloses.get(dialog);
  if (!pending) return false;
  clearTimeout(pending.timer);
  pending.panel.removeEventListener('transitionend', pending.onEnd);
  pendingDialogCloses.delete(dialog);
  return true;
}

window.openDialogAnimated = function openDialogAnimated(dialog) {
  if (!dialog) return;
  const panel = dialog.querySelector('[data-slide-panel]');

  // Re-opened while its close animation is still running (e.g. an
  // add-to-cart fires `cart:refresh` just after the shopper dismissed the
  // drawer): cancel the pending close() and slide the panel back in.
  const wasClosing = cancelPendingDialogClose(dialog);
  if (dialog.open) {
    if (wasClosing && panel) {
      void panel.offsetHeight;
      dialog.classList.add('is-open');
    }
    return;
  }

  dialog.showModal();
  if (panel) {
    // Force a synchronous layout flush so the browser commits the panel's
    // closed position before we flip it open — otherwise the two style
    // changes can coalesce into one and the transition has nothing to
    // animate between. This works regardless of frame timing/tab focus,
    // unlike a requestAnimationFrame-based delay.
    void panel.offsetHeight;
    dialog.classList.add('is-open');
  }
};

window.closeDialogAnimated = function closeDialogAnimated(dialog) {
  if (!dialog || !dialog.open || pendingDialogCloses.has(dialog)) return;
  const panel = dialog.querySelector('[data-slide-panel]');

  if (!panel || !dialog.classList.contains('is-open')) {
    dialog.classList.remove('is-open');
    dialog.close();
    return;
  }

  dialog.classList.remove('is-open');
  const finish = () => {
    cancelPendingDialogClose(dialog);
    dialog.close();
  };
  // Only the panel's own transition counts; transitions bubbling up from
  // its children (buttons, progress bars, images) must not end it early.
  const onEnd = (event) => {
    if (event.target === panel) finish();
  };
  panel.addEventListener('transitionend', onEnd);
  pendingDialogCloses.set(dialog, { panel, onEnd, timer: setTimeout(finish, 450) });
};

// Esc: route through the animated close instead of the native instant one.
// `cancel` doesn't bubble, so listen in the capture phase.
document.addEventListener(
  'cancel',
  (event) => {
    const dialog = event.target;
    if (!(dialog instanceof HTMLDialogElement)) return;
    event.preventDefault();
    window.closeDialogAnimated(dialog);
  },
  true
);

// Any close that bypassed closeDialogAnimated (browser-forced Esc close,
// dialog.close() from other code) must not leave the panel's open state
// behind for the next showModal().
document.addEventListener(
  'close',
  (event) => {
    const dialog = event.target;
    if (!(dialog instanceof HTMLDialogElement)) return;
    cancelPendingDialogClose(dialog);
    dialog.classList.remove('is-open');
  },
  true
);

/* Auto-submit any localization form (footer, header, nav drawer) when a
   selector changes. Delegated so it also covers sections re-rendered by
   the theme editor; guarded so the listener is never added twice. */
if (!window.__localizationAutoSubmit) {
  window.__localizationAutoSubmit = true;
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-localization-select]');
    if (select && select.form) select.form.submit();
  });
}
